import React, { useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from "recharts";

const productMixData = [
  { name: "Shampoo", value: 22, revenue: 4004000, color: "#DC2626" },
  { name: "Body Wash", value: 18, revenue: 3276000, color: "#D4AF37" },
  { name: "Toothpaste", value: 16, revenue: 2912000, color: "#2563EB" },
  { name: "Soap (Bar)", value: 15, revenue: 2730000, color: "#059669" },
  { name: "Lotion", value: 13, revenue: 2366000, color: "#7C3AED" },
  { name: "Others", value: 16, revenue: 2912000, color: "#EA580C" },
];

const formatPHP = (v) => `₱${(v / 1000000)?.toFixed(2)}M`;

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent } = props;
  return (
    <g>
      <text x={cx} y={cy - 10} textAnchor="middle" fill="#0F172A" style={{ fontFamily: "var(--font-heading)", fontSize: "14px", fontWeight: 700 }}>
        {payload?.name}
      </text>
      <text x={cx} y={cy + 12} textAnchor="middle" fill="#475569" style={{ fontFamily: "var(--font-data)", fontSize: "13px", fontWeight: 600 }}>
        {(percent * 100)?.toFixed(1)}%
      </text>
      <Sector cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius + 6} startAngle={startAngle} endAngle={endAngle} fill={fill} />
      <Sector cx={cx} cy={cy} innerRadius={outerRadius + 10} outerRadius={outerRadius + 14} startAngle={startAngle} endAngle={endAngle} fill={fill} />
    </g>
  );
};

export default function ProductMixChart() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="card p-4 md:p-6 chart-panel-depth">
      <div className="mb-4">
        <h3 className="font-heading text-lg md:text-xl font-semibold" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Product Mix</h3>
        <p className="font-caption text-sm mt-0.5" style={{ color: '#475569' }}>Revenue distribution by category</p>
      </div>
      <div className="flex flex-col lg:flex-row items-center gap-3 md:gap-4">
        <div className="w-full lg:w-1/2 h-44 sm:h-48 md:h-52" aria-label="Product Mix Pie Chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                activeIndex={activeIndex}
                activeShape={renderActiveShape}
                data={productMixData}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={80}
                dataKey="value"
                onMouseEnter={(_, index) => setActiveIndex(index)}
              >
                {productMixData?.map((entry, index) => (
                  <Cell key={entry?.name} fill={entry?.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="w-full lg:w-1/2 space-y-2">
          {productMixData?.map((item, idx) => (
            <button
              key={item?.name}
              className={`w-full flex items-center gap-2 p-2 rounded-lg transition-all duration-150 hover:bg-muted text-left ${activeIndex === idx ? "bg-muted" : ""}`}
              onMouseEnter={() => setActiveIndex(idx)}
              onClick={() => setActiveIndex(idx)}
            >
              <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: item?.color }} />
              <span className="font-caption text-sm font-medium flex-1 min-w-0 truncate" style={{ color: '#1E293B' }}>{item?.name}</span>
              <span className="font-data text-sm font-semibold" style={{ color: '#475569' }}>{item?.value}%</span>
              <span className="font-data text-sm font-medium hidden sm:block" style={{ color: '#1E293B' }}>{formatPHP(item?.revenue)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}